"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBookings = void 0;
var client_1 = require("@apollo/client");
var react_1 = require("react");
var booking_1 = require("../ressources/graph/queries/booking");
var useBookings = function (establishmentId) {
    var _a = (0, client_1.useQuery)(booking_1.GET_BOOKINGS, {
        variables: {
            establishmentId: establishmentId,
        },
    }), data = _a.data, loading = _a.loading, error = _a.error, subscribeToMore = _a.subscribeToMore, updateQuery = _a.updateQuery, refetch = _a.refetch;
    (0, client_1.useSubscription)(booking_1.SUBSCRIBE_BOOKINGS, {
        skip: loading || !establishmentId,
        variables: {
            establishmentId: establishmentId,
        },
    });
    (0, react_1.useEffect)(function () {
        var unsubscribe = subscribeToMore({
            document: booking_1.SUBSCRIBE_BOOKINGS,
            variables: {
                establishmentId: establishmentId,
            },
            updateQuery: function (previousQueryResult, _a) {
                var subscriptionData = _a.subscriptionData;
                if (!subscriptionData.data || !subscriptionData.data.booking) {
                    return previousQueryResult;
                }
                var booking = subscriptionData.data.booking;
                var filteredBookings = previousQueryResult.bookings.filter(function (currentBooking) { return currentBooking.id !== booking.id; });
                return {
                    bookings: __spreadArray(__spreadArray([], filteredBookings, true), [booking], false),
                };
            },
        });
        return function () {
            unsubscribe();
        };
    }, [subscribeToMore]);
    return {
        data: data,
        loading: loading,
        error: error,
        refetch: refetch,
    };
};
exports.useBookings = useBookings;
